import { render } from "./BoxWithPublicNews.vue?vue&type=template&id=40fbf9b6&scoped=true&ts=true"
import script from "./BoxWithPublicNews.vue?vue&type=script&lang=ts"
export * from "./BoxWithPublicNews.vue?vue&type=script&lang=ts"

import "./BoxWithPublicNews.vue?vue&type=style&index=0&id=40fbf9b6&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fbf9b6"]])

export default __exports__